import { createSlice } from '@reduxjs/toolkit';
import initialState from './organizationSapActivitiesContactsinitialstate';
import { _setContactKeyId } from './organizationSapActivitiesContactsActions';

export const organizationSapActivitiesContactsSlice = createSlice({
  name: 'getOrganizationSapActivitiesContactsData',
  initialState,
  reducers: {
    newOrganizationSapActivitiesContactForm: (state, action) => action.payload,
    getOrganizationSapActivitiesContactForm: (state, action) => action.payload,
    setContactKeyId: _setContactKeyId,
  },
});

export const {
  newOrganizationSapActivitiesContactForm,
  getOrganizationSapActivitiesContactForm,
  setContactKeyId,
} = organizationSapActivitiesContactsSlice.actions;

export default organizationSapActivitiesContactsSlice.reducer;
